// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ec005350","351":"5e033a13","787":"6a027eee","792":"7f179bdd"}[chunkId] + ".chunk.js";
};